import { TextField, styled } from '@mui/material'

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) =>
    prop !== 'isError' && prop !== 'isLongError' && prop !== 'labelLength',
})<{
  isError: boolean
  isLongError: boolean
  labelLength?: number
}>(({ theme, isError, isLongError, labelLength }) => ({
  '& .MuiFormControl-root': {
    height: theme.spacing(8),
  },
  '& .MuiInputBase-root': {
    marginTop: 0,
  },
  '& .MuiFormHelperText-root': {
    color: isError ? '' : '#262626',
  },
  [theme.breakpoints.only('md')]: {
    '& label': {
      top: '-7px',
    },
  },
  [theme.breakpoints.down('xs')]: {
    ...(isLongError ? { marginBottom: theme.spacing(6) } : {}),
  },
  '& .MuiInputLabel-shrink': {
    [theme.breakpoints.only('xs')]: {
      ...(labelLength && labelLength >= 34
        ? {
            transform: 'translate(0, 5px) scale(0.857)',
          }
        : {}),
    },
  },
  '& textarea': {
    paddingLeft: 0,
  },
}))
